import React, { useEffect, useState } from "react";
import { FieldValues, UseFormRegister } from "react-hook-form";

// import Alert, { AlertVariants } from "src/components/Alert";
import Button from "src/components/Button";
import Input, { InputTypes } from "src/components/Input";
import { useIsMobile } from "src/hooks/useIsMobile";
import { FirebaseDataService } from "src/services/Firebase/data";

import { VALIDATION_MESSAGES } from "src/constants/validation";
import styled from "styled-components";
import { StyledForm } from "src/pages/ChangePassword";
import { colors } from "src/styles";
import { HorizontalTabs } from "src/components/Tabs/HorizontalTabs";
import { ID, LocationSpecificWashroomLogsForTable } from "src/types";
import { CleaningLogsTable } from "../../WashroomLogsTab/CleaningLogsTable";
import { NoTicketsMessage, PaginationContainer } from "src/components/ListScreen";
import { useParams } from "react-router-dom";
import { FormContainer } from "src/pages/DynamicFormList/styles";
// import CleaningDateInput from "./components/CleaningDateInput";
import moment from "moment";
import { Pagination } from "src/components/Pagination";
import { NumberParam, useQueryParam } from "use-query-params";
import { useDispatch } from "react-redux";
import { setOpenedWashroomLogsPage as setPageStore } from "src/redux/actions/openedPages";
import CustomToast from "src/components/atoms/CustomToast";

interface WashroomLogsInputFormProps {
  onSubmit: () => void;
  isValid: boolean;
  register: UseFormRegister<FieldValues>;
  loading: boolean;
  error?: string;
  errors?: any;
  labelMessage: string;
  validateEmployeeId?: any;
  validationError?: string;
  setValue?: any;
  trigger?: any;
  submitSuccess: boolean;
  locationName: string;
  isMetroLinxClient: boolean;
  isCityOfMarkhamClient: boolean;
}

export const WashroomLogsInputForm: React.FC<WashroomLogsInputFormProps> = ({
  onSubmit,
  register,
  isValid,
  loading,
  // error,
  // errors,
  labelMessage,
  validateEmployeeId,
  validationError,
  // setValue,
  // trigger,
  submitSuccess,
  locationName,
  isMetroLinxClient,
  isCityOfMarkhamClient,
}) => {
  const { isMobile } = useIsMobile();
  const [activeTab, setActiveTab] = useState<string>("1");
  const [currentCleaningLogsPage, setCurrentCleaningLogsPage] = useState<LocationSpecificWashroomLogsForTable[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  // const [startDateTime] = useState(() => new Date(Date.now()));
  // const [endDateTime] = useState(() => new Date(Date.now()));
  const [cleaningLogs, setCleaningLogs] = useState<LocationSpecificWashroomLogsForTable[]>([]);

  const DEFAULT_PAGE_SIZE = 100;
  const INITIAL_LAST_PAGE = 1000000000;

  const [openedWashroomLogsPage, setOpenedWashroomLogsPage] = useQueryParam("openedWashroomLogsPage", NumberParam);
  const [lastPage, setLastPage] = useState<number>(INITIAL_LAST_PAGE);
  const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);

  const dispatch = useDispatch();

  const pageNum = openedWashroomLogsPage || 1;

  const { locationId, washroomId } = useParams();

  const tabs = [
    { eventKey: "1", label: "Cleaning Logs" },
    { eventKey: "2", label: "Add Log" },
  ];

  const getPageSize = async () => {
    try {
      const { data } = await FirebaseDataService.getWashroomLogsPageSize();
      setPageSize(data || DEFAULT_PAGE_SIZE);
    } catch (e) {
      setPageSize(DEFAULT_PAGE_SIZE);
    }
  };

  const getRecentCleaningLogs = (logs: LocationSpecificWashroomLogsForTable[]) => {
    const fromDate =
      isMetroLinxClient || isCityOfMarkhamClient ? moment().subtract(1, "days") : moment().subtract(7, "days");

    const finalLogs = logs
      .filter((log) => moment(log.cleaningDate).isAfter(fromDate))
      .sort((a, b) => moment(b.startTime).valueOf() - moment(a.startTime).valueOf()); // newest first

    // if (isMetroLinxClient) {
    //   return finalLogs;
    // }

    return finalLogs;
  };

  const getWashroomLogs = async () => {
    setIsLoading(true);

    if (!lastPage || (lastPage && pageNum <= lastPage)) {
      try {
        if (locationId) {
          const { data: washroomLogs } = await FirebaseDataService.getWashroomLogsByLocationId(
            locationId,
            DEFAULT_PAGE_SIZE,
          );

          const sortedLogs = getRecentCleaningLogs(washroomLogs);
          // const resultClientsPageArray = sortedLogs.slice((pageNum - 1) * pageSize, pageNum * pageSize);
          let resultClientsPageArray = sortedLogs
            .filter((log) => log.washroomId === washroomId)
            .slice((pageNum - 1) * pageSize, pageNum * pageSize);

          if (!isMetroLinxClient && !isCityOfMarkhamClient) {
            resultClientsPageArray = resultClientsPageArray.slice(0, 2);
          }

          setCleaningLogs(sortedLogs);

          setCurrentCleaningLogsPage(resultClientsPageArray);
          setLastPage(Math.ceil(sortedLogs.length / pageSize));
        }
      } catch (error) {
        console.error("Error fetching Washroom logs", error);
      }
    }

    setIsLoading(false);
  };

  const onPageChangeClick = (pageNumber: number) => {
    setOpenedWashroomLogsPage(pageNumber);
    dispatch(setPageStore(pageNumber));
    setCurrentCleaningLogsPage(cleaningLogs.slice((pageNumber - 1) * pageSize, pageNumber * pageSize));
  };

  useEffect(() => {
    setIsLoading(true);
    getPageSize().finally(() => getWashroomLogs());
  }, [pageSize]);

  useEffect(() => {
    getWashroomLogs();
  }, []);

  const onRowClick = (id: ID) => console.log(id);

  return (
    <>
      <Content>
        <ContentFrame $isMobile={isMobile}>
          <LocationTitleContainer>
            <LocationTitle>{locationName}</LocationTitle>
          </LocationTitleContainer>
          <HorizontalTabs
            tabs={tabs.map((tab) => ({
              eventKey: tab.eventKey,
              label: tab.label,
              content: activeTab === tab.eventKey ? <></> : null,
            }))}
            isWashroomLogsTabs={true}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            labelStyles={{ fontFamily: "Roboto", fontStyle: "normal", fontWeight: 700, fontSize: 16 }}
          />

          {activeTab === "1" ? (
            <>
              {currentCleaningLogsPage?.length ? (
                <CleaningLogsTable
                  onRowClick={onRowClick}
                  isLoading={isLoading}
                  headers={["Name", "Cleaning Date", "Time"]}
                  data={currentCleaningLogsPage}
                />
              ) : (
                <NoTicketsMessage $isMobile={isMobile}>No cleaning logs available</NoTicketsMessage>
              )}
              {isMetroLinxClient && (
                <PaginationContainer>
                  <Pagination
                    totalCount={cleaningLogs.length}
                    pageSize={pageSize}
                    onPageChange={onPageChangeClick}
                    currentPage={pageNum}
                  />
                </PaginationContainer>
              )}
            </>
          ) : (
            <>
              <FormContainer>
                <FormLabel>{labelMessage}</FormLabel>
                <InputForm $isMobile={isMobile}>
                  {isMetroLinxClient && (
                    <>
                      <Input
                        controlId="employee-id"
                        type={InputTypes.text}
                        label="Employee ID"
                        validation={register("employeeId", {
                          required: {
                            value: true,
                            message: VALIDATION_MESSAGES.required,
                          },
                          onBlur: (e) => validateEmployeeId(e.target.value),
                        })}
                        // error={errors}
                      />
                      {validationError && <div style={{ color: "red", fontSize: "14px" }}>{validationError}</div>}
                    </>
                  )}

                  <Input
                    controlId="first-name"
                    type={InputTypes.text}
                    label="First Name"
                    validation={register("firstName", {
                      required: {
                        value: true,
                        message: VALIDATION_MESSAGES.required,
                      },
                    })}
                    disabled={isMetroLinxClient}
                  />

                  <Input
                    controlId="last-name"
                    type={InputTypes.text}
                    label="Last Name"
                    validation={register("lastName", {
                      required: {
                        value: true,
                        message: VALIDATION_MESSAGES.required,
                      },
                    })}
                    disabled={isMetroLinxClient}
                  />

                  {/* <CleaningDateInput
                    date={startDateTime}
                    $isMobile={isMobile}
                    label="Start Time:"
                    valueComponent="p"
                    fieldName="startTime"
                    height="65px"
                    id={"1"}
                    register={register}
                    setValue={setValue}
                    trigger={trigger}
                    maxDate={new Date()}
                    minDate={new Date()}
                    // disabled
                  /> */}

                  {/* <CleaningDateInput
                    date={endDateTime}
                    $isMobile={isMobile}
                    label="End Time:"
                    valueComponent="p"
                    fieldName="endTime"
                    height="65px"
                    id={"2"}
                    register={register}
                    setValue={setValue}
                    trigger={trigger}
                    maxDate={new Date()}
                    minDate={new Date()}
                    // disabled
                  /> */}
                </InputForm>
                <ButtonContainer>
                  <ButtonWrapper>
                    <Button
                      text="Submit Details"
                      type="submit"
                      disabled={!isValid}
                      loading={loading}
                      onClick={onSubmit}
                    />
                  </ButtonWrapper>
                </ButtonContainer>
              </FormContainer>
            </>
          )}
        </ContentFrame>
      </Content>
      <CustomToast
        success={submitSuccess}
        isToastVisible={submitSuccess}
        title={<strong>Sucess</strong>}
        message={<p>{labelMessage}</p>}
      />
    </>
  );
};

const Content = styled.div`
  padding-top: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media screen and (max-width: 1369px) {
    padding-top: 100px;
  }
`;

const LocationTitleContainer = styled.div`
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e0e0e0;
`;

const LocationTitle = styled.h1`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #333333;
  margin: 0;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const ButtonWrapper = styled.div`
  width: 100%;
  max-width: 617px;
  display: flex;
  flex-direction: column-reverse;
`;

const FormLabel = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  text-align: center;
  color: #555555;
`;

const InputForm = styled(StyledForm)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  div {
    max-width: 617px;
    text-align: left;
  }
`;

export const ContentFrame = styled.div<{ $isMobile?: boolean }>`
  padding: 30px;
  background-color: ${colors.white.default};
  box-shadow: 0px 4px 120px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: ${({ $isMobile }: { $isMobile?: boolean }) => ($isMobile ? "100%" : "60%")};
`;
